import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useGetUserQuery } from "store";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Text,
    Box,
    Link as ChakraLink,
    Grid,
    GridItem,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Spinner,
    Center,
    Checkbox,
} from "@chakra-ui/react";

const UserDetail = () => {
    const { id } = useParams();
    const { data: userData, isLoading, error } = useGetUserQuery(id);
    const navigate = useNavigate();
    
    const handleUpdateClick = () => {
        navigate(`/user/${id}/update`);
    };

    if(isLoading) {
        return (
            <Center>
                <Spinner size="xl" />
            </Center>
        );
    }

    if(error) {
        return <Text> Error fetching user details: {error.message}</Text>;
    }

    return (
        <Box mt={20} p={4}>
            <Card boxShadow="md" borderRadius="2xl" overflow="hidden" p={4} border="1px solid" borderColor="gray.300">
                <CardHeader borderBottom="1px solid" borderColor="blue.200">
                    <Box textAlign="center" mb={4}>
                        <Text fontSize="2xl" fontWeight="bold">
                            {userData?.username} Details
                        </Text>
                    </Box>
                </CardHeader>

                <CardBody>
                    <Box overflow="auto" border="1px solid" borderRadius="md" borderColor="gray.300">
                        <Table variant="striped" colorScheme="blue" size="md" borderRadius="md" overflow="hidden">
                            <Thead>
                                <Tr>
                                    <Th colSpan={11} bg="gray.200" textAlign="center" p={4} borderTopRadius="md">
                                        <Text fontSize="2xl" fontFamily="Arial, sans-serif" fontWeight="bold">
                                            DATA
                                        </Text>
                                    </Th>
                                </Tr>
                            </Thead>

                            <Tbody>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Username</strong>
                                    </Td>
                                    <Td fontSize="md">{userData.username}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Name</strong>
                                    </Td>
                                    <Td fontSize="md">{userData.first_name}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Surname</strong>
                                    </Td>
                                    <Td fontSize="md">{userData.last_name}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Admin</strong>
                                    </Td>
                                    <Td>
                                        <Checkbox isChecked={userData.is_hospital_admin} isReadOnly />
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Receptionist</strong>
                                    </Td>
                                    <Td>
                                        <Checkbox isChecked={userData.is_receptionist} isReadOnly />
                                    </Td>
                                </Tr>
                            </Tbody>
                        </Table>
                    </Box>
                </CardBody>

                <CardFooter p={4} borderTop="1px solid" borderColor="gray.300">
                    <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                        <GridItem>
                            <ChakraLink as={Link} to="/users" color="blue.500">
                                Back to List
                            </ChakraLink>
                        </GridItem>
                        <GridItem textAlign="right">
                            <Button colorScheme="blue"
                            onClick={(e) => {
                                handleUpdateClick();
                                e.stopPropagation();
                            }}>
                                Update
                            </Button>
                        </GridItem>
                    </Grid>
                </CardFooter>
            </Card>
        </Box>
    );
}

export default UserDetail;